import { render, staticRenderFns } from "./JobCardFreelancer.htm?vue&type=template&id=600fc330&scoped=true&"
import script from "./JobCardFreelancer.ts?vue&type=script&lang=js&"
export * from "./JobCardFreelancer.ts?vue&type=script&lang=js&"
import style0 from "./JobCardFreelancer.scss?vue&type=style&index=0&id=600fc330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600fc330",
  null
  
)

export default component.exports